module.exports = __webpack_public_path__ + "img/hotproduct-1.ba7e59d3.jpg";